<div class="modal-content">
  <div class="modal-header">
    <button class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
      <fa-icon [icon]="faClose"></fa-icon>
    </button>
  </div>
  <div class="modal-body">
    <div class="row h-100">
      <div class="col-md-12">
        <img src="/assets/img/Logo-river-app.svg" alt="Imagen de bienvenida" class="img-fluid" style="width: 20%;justify-self: center;display: flex;"/>
      </div>
      <div class="col-md-12">
        <p class="title-text">
          Bienvenido
        </p>
        <p class="subCopyText">
          Estamos encantados de tenerte con nosotros. Tu cuenta ha sido creada con éxito y ahora formas parte de nuestra
          comunidad.
          
          Si necesitas ayuda, no dudes en contactarnos, estamos aquí para asistirte en todo lo que necesites.
        </p>
      </div>
      <div class="col-md-12">
        <img src="assets/img/modalBienvenida.svg" alt="Imagen de bienvenida" class="img-fluid" style="width: 100%;"/>
      </div>
    </div>
  </div>
</div>